import { VideotestimonialProps } from '@/interfaces';
import React from 'react';
import { projectImages } from '../../../public/Assets/Images';
import TypoGraphy from '@/typography';
import './index.scss';
import Image from 'next/image';
import { gumletLoader } from '@/utils/gumlet';
const VideoTestimonial = React.forwardRef(({
  image,
  name,
  designation,
  videoIndex,
  activeIndex,
  setIndex,
  playing,
  handleClick
}: VideotestimonialProps, videoRef: any) => {
  const handleVideoClick = () => {
    handleClick(videoIndex);
    setIndex(videoIndex);
  };
  return <div className="video_testimonial_wrapper" onClick={handleVideoClick}>
      <div className="relative_section">
        <video src={image} autoPlay={false} muted={false} controls={false} controlsList="nodownload" loop={true} ref={videoIndex === activeIndex ? videoRef : null} />
      </div>
      <div className="absolute_section">
        <div className="image_wrapper">
          <Image loader={gumletLoader} width={38} height={38} className={!playing ? "playing_image" : "pause_image"} src={playing ? projectImages.pause : projectImages.playButtonLightBg} alt="play" />
        </div>
        <div className="learner_details">
          <TypoGraphy text={name} variant='Desktop/Body 2/M | 14 |120' color='white' />
          <TypoGraphy text={designation} variant='Desktop/Body 2/R | 14 |120' />
        </div>
      </div>
    </div>;
});
export default VideoTestimonial;